import { render, staticRenderFns } from "./MoveProject.vue?vue&type=template&id=f9c006e4&"
import script from "./MoveProject.vue?vue&type=script&lang=js&"
export * from "./MoveProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports